<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div class="common_title">
        当前持仓
        <TopPartner @refreshTopPartner="handleSearch"></TopPartner>
      </div>

      <div class="page-actions">
        <div class="select">
          <div class="item">
            <!-- <div class="txt">用户UID</div> -->
            <div class="ipt">
              <el-input
                placeholder="用户UID"
                clearable
                v-model="userId"
                class="userUid_ipt"
                size="mini"
              >
                <!-- <img :src="userUid" alt="" slot="prefix" class="userUid" /> -->
              </el-input>
            </div>
          </div>
          <div class="item">
            <el-select v-model="source" size="mini" placeholder="仓位类型" @change="handleSearch">
              <el-option label="全部" value="ALL" />
              <el-option label="正常仓位" value="NORMAL" />
              <el-option label="体验仓位" value="POSITION_EXPERIENCE" />
            </el-select>
          </div>

          <div class="item">
            <!-- <div class="txt">合伙人UID</div> -->
            <div class="ipt">
              <el-input
                placeholder="合伙人UID"
                clearable
                v-model="channelUserId"
                class="userUid_ipt"
                size="mini"
              >
                <!-- <img :src="channel" alt="" slot="prefix" class="userUid" /> -->
              </el-input>
            </div>
          </div>

          <div class="item">
            <!-- <div class="txt">合伙人UID</div> -->
            <div class="ipt">
              <el-input
                placeholder="仓位ID"
                clearable
                v-model="id"
                class="userUid_ipt"
                size="mini"
              >
                <!-- <img :src="channel" alt="" slot="prefix" class="userUid" /> -->
              </el-input>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">仓位模式</div> -->
            <div class="ipt">
              <el-select
                size="mini"
                @change="changeCoin"
                :rules="[
                  { required: true, message: '请选择', trigger: 'change' },
                ]"
                v-model="positionType"
                placeholder="请选择"
              >
                <el-option label="全部仓位模式" value=""> </el-option>
                <el-option
                  v-for="item in [
                    { id: 1, value: '全仓' },
                    { id: 2, value: '逐仓' },
                  ]"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">买卖方向</div> -->
            <div class="ipt">
              <el-select
                size="mini"
                @change="changeCoin"
                :rules="[
                  { required: true, message: '请选择', trigger: 'change' },
                ]"
                v-model="positionSide"
                placeholder="请选择"
              >
                <el-option label="全部买卖方向" value=""> </el-option>
                <el-option
                  v-for="item in [
                    { id: 1, value: '开多' },
                    { id: 2, value: '开空' },
                  ]"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <!-- <div class="item">
            <div class="txt">订单ID</div>
            <div class="ipt">
              <el-input placeholder="订单ID" clearable v-model="orderId">
              </el-input>
            </div>
          </div> -->
          <!-- <div class="item">
            <div class="txt">仓位ID</div>
            <div class="ipt">
              <el-input placeholder="邀请人UID" clearable v-model="inviteBy">
              </el-input>
            </div>
          </div> -->
          <div class="item">
            <!-- <div class="txt">合约名称</div> -->
            <div class="ipt">
              <el-select
                size="mini"
                filterable
                @change="changeCoin"
                :rules="[
                  { required: true, message: '请选择', trigger: 'change' },
                ]"
                v-model="symbol"
                placeholder="请选择"
              >
                <el-option label="全部合约名称" value=""> </el-option>
                <el-option
                  v-for="item in symbolList"
                  :key="item.id"
                  :label="item.symbol"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">开仓时间</div> -->
            <div class="ipt">
              <el-date-picker
                size="mini"
                v-model="value1"
                type="daterange"
                align="right"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                unlink-panels
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="changeTime($event)"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </div>
          </div>
          <!-- <div class="item">
            <el-button size="mini" @click="searchYesterday">昨日</el-button>
          </div>
          <div class="item">
            <el-button size="mini" @click="searchToday">今日</el-button>
          </div> -->
          <div class="item">
            <div class="item-sle">
              <div class="tit">特殊账号</div>
              <el-select size="mini" v-model="type" placeholder="特殊账号">
                <el-option
                  v-for="item in [
                    { id: 1, value: '隐藏' },
                    { id: 2, value: '显示' },
                  ]"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <el-button size="mini" type="primary" @click="handleSearch"
              >查询</el-button
            >
          </div>
        </div>
      </div>
      <div class="pl_total_box">
        <div class="pl_total">
          <span>未结算盈亏汇总</span>
          <span></span>
          <span>{{ totalProfit | fixD(6) }}</span>
          <span>USDT</span>
        </div>
        <div class="pl_total">
          <span>已结算盈亏汇总</span>
          <span></span>
          <span>{{ totalRealizedProfit | fixD(6) }}</span>
          <span>USDT</span>
        </div>

        <div class="pl_total">
          <span>持仓保证金汇总</span>
          <span></span>
          <span>{{ totalOpenOrderMarginFrozen | fixD(6) }}</span>
          <span>USDT</span>
        </div>

        <div class="pl_total">
          <span>持仓手续费汇总</span>
          <span></span>
          <span>{{ totalFee | fixD(6) }}</span>
          <span>USDT</span>
        </div>
      </div>
      <user-list @refresh="refreshList"></user-list>
    </el-card>
    <!-- 添加用户信息弹框 -->
  </div>
</template>

<script>
import "./store";
import UserList from "./components/list";
import { mapState, mapActions, mapMutations } from "vuex";
import { QUERY_TYPE, PAGINATION } from "./constants";
import userUid from "@/assets/input/userUid.png";
import invite from "@/assets/input/invite.png";
import channel from "@/assets/input/channel.png";
import TopPartner from "../topPartner";
import moment from "moment";

export default {
  name: "ContractPosition",
  components: {
    UserList,
    TopPartner,
  },
  data() {
    return {
      source: "NORMAL",
      invite,
      channel,
      userUid,
      type: 1,
      positionType: "",
      positionSide: "",
      value2: "",
      dialogVisible: false,
      userId: "",
      symbol: "",
      channelId: "",
      channelUserId: "",
      orderId: "",
      inviteBy: "",
      id: "",
      // value1: [
      //   moment(new Date().getTime() - 7 * 1000 * 24 * 60 * 60).format(
      //     'YYYY-MM-DD'
      //   ),
      //   new Date().getFullYear() +
      //     '-' +
      //     (new Date().getMonth() + 1) +
      //     '-' +
      //     new Date().getDate(),
      // ],
      value1: "",
      pickerOptions: {
        disabledDate(time) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          const cell = new Date(time);
          cell.setHours(0, 0, 0, 0);
          return cell.getTime() > today.getTime();
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("contractPosition", [
      "queryType",
      "queryTypeList",
      "pagination",
      "symbolList",
      "totalProfit",
      "totalFee",
      "totalOpenOrderMarginFrozen",
      "totalRealizedProfit",
      "orderBy",
    ]),
    ...mapState(["userInfo"]),
    ...mapState("topPartner", ["topPartner"]),
  },
  methods: {
    ...mapActions("contractPosition", [
      "list",
      "addUser",
      "getSymbolList",
      "getTotalInfo",
    ]),
    ...mapMutations("contractPosition", ["setQueryType", "setOrderBy"]),
    refreshList(data = {}) {
      this.getTotalInfo({
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        channelUserId: this.channelUserId,
        channelId: this.topPartner,
        userId: this.userId,
        symbol: this.symbol,
        type: this.type,
        positionType: this.positionType,
        source: this.source,
        positionSide: this.positionSide,
      });
      this.list({
        source: this.source,
        id: this.id,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        channelId: this.topPartner,
        channelUserId: this.channelUserId,
        userId: this.userId,
        symbol: this.symbol,
        type: this.type,
        positionType: this.positionType,
        positionSide: this.positionSide,
        orderBy: this.orderBy,
        ...this.pagination,
        ...data,
      });
    },
    changeTime(e) {
      this.getTotalInfo({
        source: this.source,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        channelUserId: this.channelUserId,
        channelId: this.topPartner,
        userId: this.userId,
        symbol: this.symbol,
        type: this.type,
        positionType: this.positionType,
        positionSide: this.positionSide,
      });
      this.list({
        source: this.source,
        id: this.id,
        channelId: this.topPartner,
        channelUserId: this.channelUserId,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        userId: this.userId,
        symbol: this.symbol,
        type: this.type,
        positionType: this.positionType,
        orderBy: this.orderBy,
        positionSide: this.positionSide,
        ...PAGINATION,
      });
    },
    changeCoin(e) {
      this.getTotalInfo({
        source: this.source,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        channelUserId: this.channelUserId,
        channelId: this.topPartner,
        userId: this.userId,
        symbol: this.symbol,
        type: this.type,
        positionType: this.positionType,
        positionSide: this.positionSide,
      });
      this.list({
        source: this.source,
        id: this.id,
        positionType: this.positionType,
        positionSide: this.positionSide,
        channelId: this.topPartner,
        channelUserId: this.channelUserId,
        userId: this.userId,
        type: this.type,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        orderBy: this.orderBy,
        symbol: this.symbol,
        ...PAGINATION,
      });
    },
    searchYesterday() {
      this.value1 = [
        new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          (new Date().getDate() - 1),
        new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          (new Date().getDate() - 1),
      ];
      this.handleSearch();
    },
    searchToday() {
      this.value1 = [
        new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate(),
        new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate(),
      ];
      this.handleSearch();
    },
    handleSearch() {
      console.log("this.topPartner1111", this.topPartner);
      this.getTotalInfo({
        source: this.source,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        channelUserId: this.channelUserId,
        channelId: this.topPartner,
        userId: this.userId,
        symbol: this.symbol,
        type: this.type,
        positionType: this.positionType,
        positionSide: this.positionSide,
      });
      this.list({
        source: this.source,
        id: this.id,
        channelId: this.topPartner,
        channelUserId: this.channelUserId,
        positionType: this.positionType,
        positionSide: this.positionSide,
        userId: this.userId,
        type: this.type,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        orderBy: this.orderBy,
        symbol: this.symbol,
        ...PAGINATION,
      });
    },
    handleSave() {},
    closeDialog() {
      this.dialogVisible = false;
    },
    onOpen() {},
    onClose() {
      this.$refs["elForm"].resetFields();
      this.dialogVisible = false;
    },
    close() {
      // this.$emit("update:visible", false);
      this.$refs["elForm"].resetFields();
      this.dialogVisible = false;
    },
  },
  mounted() {
    console.log("this.topPartner2222", this.topPartner);
    this.getTotalInfo({
      source: this.source,
      startTime: this.value1 ? this.value1[0] : "",
      endTime: this.value1 ? this.value1[1] : "",
      channelUserId: this.channelUserId,
      channelId: this.topPartner,
      userId: this.userId,
      symbol: this.symbol,
      type: this.type,
      positionType: this.positionType,
      positionSide: this.positionSide,
    });
    this.getSymbolList();
    this.list({
      source: this.source,
      channelId: this.topPartner,
      channelUserId: this.channelUserId,
      userId: this.userId,
      type: this.type,
      positionType: this.positionType,
      positionSide: this.positionSide,
      symbol: this.symbol,
      startTime: this.value1 ? this.value1[0] : "",
      endTime: this.value1 ? this.value1[1] : "",
      orderBy: this.orderBy,
      id: this.id,
      ...PAGINATION,
    });
    // if (!this.symbol) {
    //   this.$message.warning('请选择合约名称')
    // } else {
    //   this.list({
    //     channelId: this.topPartner,
    //     channelUserId: this.channelUserId,
    //     userId: this.userId,
    //     symbol: this.symbol,
    //     ...PAGINATION,
    //   })
    // }
  },
  beforeDestroy() {
    this.setOrderBy("openTime,desc");
  },
};
</script>

<style lang="less" src="../../../styles/button.less" scoped></style>
